
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">虚拟人公司羽迹科技：数字化世界的引领者</h2>
                    <div class="time">2023-06-14 10:00:10</div>
                    <div class="start">
                        在数字化时代，虚拟人技术正迅速崛起，深圳羽迹科技有限公司作为虚拟人技术领域的引领者，以其卓越的创新能力和技术实力，成为数字化世界的引领者。羽迹科技凭借其出色的产品和解决方案，正在推动着虚拟人技术的发展，为用户和企业带来了全新的数字化体验。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/203.png" alt="虚拟人公司羽迹科技：数字化世界的引领者" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            作为一家专注于人工智能和图形图像算法研发的科技企业，羽迹科技于2017年11月10日成立。公司致力于高仿真3D数字人设计、生成以及AI交互等技术的研发和应用。通过自主研发的算法，羽迹科技能够从单张或多张照片中快速生成高保真的3D数字人形象，极大地简化了数字人创作的流程，提供了更加逼真和个性化的数字化体验。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            羽迹科技拥有多项自主知识产权，其领先的技术为企业和个人用户提供了一流的数字人解决方案。无论是在医美、美妆、元宇宙、试穿、发型、VR还是游戏等领域，羽迹科技的产品和服务得到了广泛应用。医美行业可以利用羽迹科技的数字人技术进行术前仿真和效果展示，为患者提供更加精确和可靠的服务。虚拟试穿和发型设计领域，羽迹科技的技术为用户提供了个性化的虚拟体验，改变了传统的购物和美容方式。同时，在虚拟现实和游戏产业中，羽迹科技的数字人技术增强了用户的互动性和参与度，打造了更加沉浸式的虚拟体验。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            羽迹科技不仅注重技术创新，也致力于为用户和企业提供简单、高效、低成本的数字人技术服务。公司提供了一整套的数字人解决方案，包括算法、云计算、软件开发和授权等，满足了不同领域企业的需求。羽迹科技坚持自主研发的理念，不断改进和创新技术，推动着数字人技术的发展和应用。
                        </div>
                    </div>

                    <div class="end">
                        虚拟人公司羽迹科技凭借其卓越的创新能力和技术实力，成为数字化世界的引领者。通过高仿真的3D数字人设计和生成，以及与人工智能的交互，羽迹科技打造了全新的数字化体验，引领着数字人技术的发展潮流。未来，羽迹科技将继续致力于数字人技术的创新和应用，为用户和企业带来更多令人惊叹的数字化体验，开创数字化世界的新纪元。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "虚拟形象与直播的元宇宙社交?-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "虚拟形象与直播的元宇宙社交?,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "二次元文化随着Z世代消费力量的崛起，也逐渐突破小众圈层走进品牌营销的大众视野",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo203.vue